import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HeaderComponent } from 'src/app/admin/core/components/navs/header/header.component';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { AppComponent } from 'src/app/app.component';
import { SideNavComponent } from 'src/app/admin/core/components/navs/side-nav/side-nav.component';
import { DashboardComponent } from 'src/app/admin/core/components/dashboard/dashboard.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { MaterialModules } from 'src/app/shared/modules/material.module';
import { IconModule } from 'src/app/shared/modules/icon.module';
import { SharedModule } from 'src/app/shared/modules/shared.module';
import { CheckboxComponent } from 'src/app/shared/components/dynamic-component-shared/checkbox/checkbox.component';
import { DropdownComponent } from 'src/app/shared/components/dynamic-component-shared/dropdown/dropdown.component';
import { TextareaComponent } from 'src/app/shared/components/dynamic-component-shared/textarea/textarea.component';
import { TextboxComponent } from 'src/app/shared/components/dynamic-component-shared/textbox/textbox.component';
import { RadioComponent } from 'src/app/shared/components/dynamic-component-shared/radio/radio.component';
import { MatTabsModule } from '@angular/material/tabs';
import { AdminHomePageComponent } from 'src/app/admin/core/pages/admin-home-page/admin-home-page.component';
import { TableComponent } from 'src/app/shared/components/dynamic-component-shared/table/table.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { QRCodeModule } from 'angularx-qrcode';

import { CreerPersonnephysiqueComponent } from 'src/app/shared/components/creer-personnephysique/creer-personnephysique.component';
import { LoginComponent } from 'src/app/shared/components/login/login/login.component';
import { MenuComponent } from 'src/app/shared/components/menu/menu.component';
import { CategorieComponent } from 'src/app/shared/components/categorie/categorie.component';
import { ProduitAdminComponent } from 'src/app/shared/components/produit-admin/produit-admin.component';
import { DialogComponent } from 'src/app/shared/components/dialogs/dialog.component';
import { PersonMoraleComponent } from 'src/app/shared/components/personnemorale/personnemorale.component';
import { NgImageSliderModule } from 'ng-image-slider';
import { CdkMenuModule } from '@angular/cdk/menu';
import { MenuModule } from '@syncfusion/ej2-angular-navigations';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TabContentComponent } from 'src/app/shared/components/tab-content/tab-content.component';
import { LogoutComponent } from 'src/app/shared/components/logout/logout.component';
import { BibliothequeMultimediaComponent } from 'src/app/shared/components/bibliotheque-multimedia/bibliotheque-multimedia.component';
import { EntiteDirective } from 'src/app/shared/directives/entite.directives';
import { AccueilComponent } from 'src/app/user/components/accueil/accueil.component';
import { HeaderUserComponent } from 'src/app/user/navs/header-user/header-user.component';
import { NotificationComponent } from 'src/app/user/components/notification/notification.component';
import { FooterUserComponent } from 'src/app/user/navs/footer-user/footer-user.component';
import { FournisseursComponent } from 'src/app/user/components/fournisseurs/fournisseurs.component';
import { CataloguesComponent } from 'src/app/user/components/catalogues/catalogues.component';
import { DetailCatalogueComponent } from 'src/app/user/components/detail-catalogue/detail-catalogue.component';
import { NgxChartModule } from 'ngx-chart';
import { AssociesComponent } from 'src/app/user/components/associes/associes.component';
import { MesDevisComponent } from 'src/app/user/components/mes-devis/mes-devis.component';
// import { NgApexchartsModule } from 'ng-apexcharts';
import { JwtModule } from '@auth0/angular-jwt';
import { BasicAuthInterceptor } from 'src/app/shared/core/interceptors/basic-auth.interceptor';
import { VisualisationComponent } from 'src/app/shared/components/dialogs/visualisation/visualisation.component';
import { GenericDialogComponent } from 'src/app/shared/components/dialogs/generic-dialog/generic-dialog.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FiltrePredifiniDialogComponent } from 'src/app/shared/components/dialogs/filtre-predifini-dialog/filtre-predifini-dialog.component';
import { DiaologHostComponent } from 'src/app/shared/components/dialogs/dialog-host/dialog-host';
import { SuppressionDialogComponent } from 'src/app/shared/components/dialogs/suppression-dialog/suppression-dialog.component';
import { FooterAdminComponent } from 'src/app/admin/core/components/navs/footer-admin/footer-admin.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { ChampsComponent } from 'src/app/shared/components/champs/champs.component';
import { AdminUserGroupParameterComponent } from 'src/app/shared/components/admin-user-group-parameter/admin-user-group-parameter.component';
import { ForgotPasswordComponent } from 'src/app/shared/components/forgot-password/forgot-password.component';
import { ChangerMotDePasseComponent } from 'src/app/shared/components/changer-mot-de-passe/changer-mot-de-passe.component';
import { RetrievePasswordComponent } from 'src/app/shared/components/retrieve-password/retrieve-password.component';
import { ImportFichierComponent } from 'src/app/shared/components/dialogs/import-fichier/import-fichier.component';
import { ExportFichierComponent } from 'src/app/shared/components/dialogs/export-fichier/export-fichier.component';
import { FiltrerChampComponent } from 'src/app/shared/components/dialogs/filtrer-champ/filtrer-champ.component';
import { MsalModule } from '@azure/msal-angular';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { environment } from 'src/environments/environment';
import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import { MessageService } from 'primeng/api';
import { RefEanValidationInterceptor } from 'src/app/shared/core/interceptors/ref-ean-validation.interceptor';
import { UserComponent } from 'src/app/shared/components/user/user.component';
import { CommonModule, DatePipe, DecimalPipe, UpperCasePipe } from '@angular/common';
import { AccountComponent } from 'src/app/user/components/account/account.component';
import { MatDividerModule } from '@angular/material/divider';
import { SearchProductComponent } from 'src/app/user/components/search-product/search-product.component';
import { ConfirmRemoveComponent } from 'src/app/admin/core/components/dashboard/confirm-remove/confirm-remove.component';
import { RechercheProduitComponent } from 'src/app/user/components/accueil/recherche-produit/recherche-produit.component';
import { DashboardUserComponent } from 'src/app/user/components/accueil/dashboard/dashboard.component';
import { NewsComponent } from 'src/app/user/components/accueil/news/news.component';
import { CatalogueMenuComponent } from 'src/app/user/components/catalogues/catalogue-menu/catalogue-menu.component';
import { CatalogueMenuRespComponent } from 'src/app/user/components/catalogues/catalogue-menu-resp/catalogue-menu-resp.component';
import { CatalogueMenuDialogComponent } from 'src/app/user/components/catalogues/catalogue-menu-dialog/catalogue-menu-dialog.component';
import { ProduitComponent } from 'src/app/user/components/catalogues/produit/produit.component';
import { NgxImageZoomModule } from 'ngx-image-zoom';
import { CaracProductComponent } from 'src/app/user/components/detail-catalogue/carac-product/carac-product.component';
import { MostConsultedComponent } from 'src/app/user/components/detail-catalogue/most-consulted/most-consulted.component';
import { AccessoriesComponent } from 'src/app/user/components/detail-catalogue/accessories/accessories.component';
import { ProductOptionsComponent } from 'src/app/user/components/detail-catalogue/product-options/product-options.component';
import { FournisseurComponent } from 'src/app/user/components/fournisseurs/fournisseur/fournisseur.component';
import { BurgerComponent } from 'src/app/user/navs/header-user/burger/burger.component';
import { EmailPopupDialogComponent } from 'src/app/shared/components/dialogs/email-popup-dialog/email-popup-dialog.component';
import { CarouselComponent } from 'src/app/shared/components/carousel/carousel.component';
import { RechercheAvanceeComponent } from 'src/app/user/components/mes-devis/recherche-avancee/recherche-avancee.component';
import { CguPopupComponent } from 'src/app/shared/components/cgu-popup/cgu-popup.component';
import { GestionComponent } from 'src/app/user/components/gestion/gestion.component';
import { CreateEditProductComponent } from 'src/app/user/components/gestion/create-edit-product/create-edit-product.component';
import { ExtractEntityNamePipe } from 'src/app/shared/core/pipes/entitynamepipe';
import { TemplateComponent } from 'src/app/shared/components/template/template/template.component';
import { TemplateDeuxColonneEditionComponent } from 'src/app/shared/components/template/template-deux-colonne-edition/template-deux-colonne-edition.component';
import { TemplateDeuxColonneLectureComponent } from 'src/app/shared/components/template/template-deux-colonne-lecture/template-deux-colonne-lecture.component';
import { MatSortModule } from '@angular/material/sort';
import { TextEditorComponent } from 'src/app/shared/components/text-editor/text-editor.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { ActualiteComponent } from 'src/app/shared/components/actualite/actualite.component';
import { CreateDevisComponent } from 'src/app/user/components/mes-devis/create-devis/create-devis.component';
import { InfosDevisComponent } from 'src/app/user/components/mes-devis/create-devis/infos-devis/infos-devis.component';
import { OutilsDevisComponent } from 'src/app/user/components/mes-devis/create-devis/outils-devis/outils-devis.component';
import { LignesDevisComponent } from 'src/app/user/components/mes-devis/create-devis/lignes-devis/lignes-devis.component';
import { ClosePopupComponent } from 'src/app/shared/components/dialogs/close-popup/close-popup.component';
import { GestionMarquesComponent } from 'src/app/user/components/gestion/gestion-marques/gestion-marques.component';
import { GestionFournisseursComponent } from 'src/app/user/components/gestion/gestion-fournisseurs/gestion-fournisseurs.component';
import { GestionAssocieComponent } from 'src/app/user/components/gestion/gestion-associe/gestion-associe.component';
import { GestionClientsComponent } from 'src/app/user/components/gestion/gestion-clients/gestion-clients.component';
import { TemplateParameterComponent } from 'src/app/shared/components/template/template-parameter/template-parameter.component';
import { TemplateRefactorComponent } from 'src/app/shared/components/template-refactor/template-refactor.component';
import { TemplateViewComponent } from 'src/app/shared/components/template-view/template-view.component';
import { TemplateEditComponent } from 'src/app/shared/components/template-edit/template-edit.component';
import { FormFieldHostDirective } from 'src/app/shared/directives/app-component-host.directive';
import { PrintDevisComponent } from 'src/app/user/components/mes-devis/create-devis/print-devis/print-devis.component';
import { ArticleManuscritDevisComponent } from 'src/app/user/components/mes-devis/create-devis/article-manuscrit-devis/article-manuscrit-devis.component';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { getFrenchPaginatorIntl } from 'src/app/shared/services/paginatorIntl';
import { DataTableComponent } from 'src/app/shared/components/dynamic-component-shared/data-table/data-table.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { ModaleOrdreDevisComponent } from 'src/app/user/components/mes-devis/create-devis/lignes-devis/modale-ordre-devis/modale-ordre-devis.component';
import { MultiLangueComponent } from 'src/app/shared/components/dynamic-component-shared/multi-langue/multi-langue.component';
import { DateComponent } from 'src/app/shared/components/dynamic-component-shared/date/date.component';
import { MultiSelectDropdownComponent } from 'src/app/shared/components/dynamic-component-shared/multi-select-dropdown/multi-select-dropdown.component';
import { ImageComponent } from 'src/app/shared/components/dynamic-component-shared/image/image.component';
import { SearchableTextfieldComponent } from 'src/app/shared/components/dynamic-component-shared/searchable-textfield/searchable-textfield.component';
import { TextboxlistComponent } from 'src/app/shared/components/dynamic-component-shared/textboxlist/textboxlist.component';
import { AddressComponent } from 'src/app/shared/components/dynamic-component-shared/address/address.component';
import { PictoComponent } from 'src/app/shared/components/dynamic-component-shared/picto/picto.component';
import { BooleanToFrenchPipe } from 'src/app/shared/core/pipes/boolean-to-french-pipe';
import { LabelComponent } from 'src/app/shared/components/dynamic-component-shared/label/label.component';
import { columnRenamePipe } from 'src/app/shared/core/pipes/column-rename-pipe';
import { DynamicTableRowComponent } from 'src/app/shared/components/dynamic-component-shared/dynamic-table-row/dynamic-table-row.component';
import { GenricTableRowComponent } from 'src/app/shared/components/dynamic-component-shared/genric-table-row/genric-table-row.component';
import { LayoutConditionsComponent } from 'src/app/shared/components/dialogs/layout-conditions/layout-conditions.component';
import { ConfirmationDialogComponent } from 'src/app/shared/components/dialogs/confirmation-dialog/confirmation-dialog.component';
import { TabExtranetComponent } from 'src/app/shared/components/tab-extranet/tab-extranet.component';
import { ImageColumnComponent } from 'src/app/shared/components/dynamic-component-shared/table/dynamic-columns/image-column/image-column.component';
import { PrimitiveColumnComponent } from 'src/app/shared/components/dynamic-component-shared/table/dynamic-columns/primitive-column/primitive-column/primitive-column.component';
import { ObjectColumnComponent } from 'src/app/shared/components/dynamic-component-shared/table/dynamic-columns/object-column/object-column.component';
import { ColorColumnComponent } from 'src/app/shared/components/dynamic-component-shared/table/dynamic-columns/color-column/color-column.component';
import { MultilangueColumnComponent } from 'src/app/shared/components/dynamic-component-shared/table/dynamic-columns/multilangue-column/multilangue-column.component';
import { PictoColumnComponent } from 'src/app/shared/components/dynamic-component-shared/table/dynamic-columns/picto-column/picto-column.component';
import { RestrictionsComponent } from 'src/app/shared/components/dialogs/restrictions/restrictions/restrictions.component';
import { FonctionalitesComponent } from 'src/app/shared/components/dialogs/restrictions/fonctionalites/fonctionalites.component';
import { ArchivesComponent } from 'src/app/shared/components/dialogs/archives/archives.component';
import { TaskSchedulerComponent } from 'src/app/shared/components/dynamic-component-shared/task-scheduler/task-scheduler.component';
import { AppMenuItemComponent } from 'src/app/shared/components/menu/app-menu-item/app-menu-item.component';
import { DroitItemComponent } from 'src/app/shared/components/droit-item/droit-item.component';
import { NestedValueDataTableComponent } from 'src/app/shared/components/dynamic-component-shared/nested-value-data-table/nested-value-data-table.component';
import { DynamicFieldFormComponent } from 'src/app/shared/components/dynamic-field-form/dynamic-field-form.component';
import { DynamicDocumentManageFieldComponent } from 'src/app/shared/components/dynamic-component-shared/dynamic-document-manage-field/dynamic-document-manage-field.component';
import { ParameterLinkComponent } from 'src/app/shared/components/dynamic-component-shared/table/dynamic-columns/parameter-link/parameter-link.component';
import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { TranslateModule, TranslateLoader, TranslatePipe } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { BackofficeMenuComponent } from 'src/app/shared/components/backoffice-menu/backoffice-menu.component';
import { NewsCarouselComponent } from 'src/app/user/components/accueil/news-carousel/news-carousel.component';
import { BeforCaracProductComponent } from 'src-befor/detail-catalogue/befor-carac-product/befor-carac-product.component';
import { BarquettesTableComponent } from 'src-befor/detail-catalogue/befor-carac-product/barquettes-table/barquettes-table.component';
import { FilmsTableComponent } from 'src-befor/detail-catalogue/befor-carac-product/films-table/films-table.component';
import { VideoComponent } from 'src/app/user/components/detail-catalogue/video/video.component';
import { PipeModule } from 'src/app/shared/modules/pipe.module';
import { DynamicContentComponent } from 'src/app/shared/components/dynamic-content/dynamic-content.component';
import { ModaleContentComponent } from 'src/app/shared/components/dynamic-content/modale-content/modale-content.component';
import { GeneralDynamicContentComponent } from 'src/app/shared/components/general-dynamic-content/general-dynamic-content.component';
import { GeneralDynamicContentItemComponent } from 'src/app/shared/components/general-dynamic-content/general-dynamic-content-item/general-dynamic-content-item.component';
import { ModalePreviewComponent } from 'src/app/shared/components/dynamic-content/modale-preview/modale-preview.component';
import { ContactComponent } from 'src/app/shared/components/contact/contact.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { PaginatorModule } from 'primeng/paginator';
import { PanelModule } from 'primeng/panel';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CarouselModule } from 'primeng/carousel';
import { GalleriaModule } from 'primeng/galleria';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { TabViewModule } from 'primeng/tabview';
import { TableModule } from 'primeng/table';
import { FileUploadModule } from 'primeng/fileupload';
import { AccordionModule } from 'primeng/accordion';
import { ToastModule } from 'primeng/toast';
import { SkeletonModule } from 'primeng/skeleton';
import { CategoriesComponent } from 'src-adisco/categories/categories.component';
import { ProductDetailComponent } from 'src-adisco/product-detail/product-detail.component';
import { GeneralInfoComponent } from 'src-adisco/product-detail/general-info/general-info.component';
import { DetailInfoComponent } from 'src-adisco/product-detail/detail-info/detail-info.component';
import { SlideProductComponent } from 'src-adisco/product-detail/slide-product/slide-product.component';

import { ButtonFieldComponent } from 'src/app/shared/components/button-field/button-field.component';
import { LinkbuttonComponent } from 'src/app/shared/components/dynamic-component-shared/table/dynamic-columns/linkbutton/linkbutton.component';
import { ProductCatalogComponent } from 'src-ironside/product-catalog/product-catalog.component';
import { ProductCatalogDialogComponent } from 'src-ironside/product-catalog/product-catalog-dialog/product-catalog-dialog.component';
import { NewProductComponent } from 'src-ironside/new-product/new-product.component';
import { NewProductDetailComponent } from 'src-ironside/new-product/new-productDetail/new-productDetail.component';
import { TabviewProductComponent } from 'src-ironside/new-product/new-productDetail/tabview-product/tabview-product.component';
import { ListProductComponent } from 'src-ironside/list-Product/list-Product.component';
import { FournisseursIronsideComponent } from 'src-ironside/fournisseurs-ironside/fournisseurs-ironside.component';
import { ListPartnersComponent } from 'src-ironside/list-partners/list-partners.component';

import { ProductComparatorComponent } from 'src-adisco/product-comparator/product-comparator.component';
import { SuppliersComponent } from 'src-adisco/suppliers/suppliers.component';
import { DetailSupplierComponent } from 'src-adisco/suppliers/detail-supplier/detail-supplier.component';
import { SlideNewsComponent } from 'src-adisco/suppliers/detail-supplier/slide-news/slide-news.component';
import { MembersComponent } from 'src-adisco/members/members.component';
import { DetailMemberComponent } from 'src-adisco/members/detail-member/detail-member.component';
import { GestionAdiscoComponent } from 'src-adisco/gestion/gestion-adisco.component';
import { MemberFileComponent } from 'src-adisco/gestion/member-file/member-file.component';
import { CustomerProspectComponent } from 'src-adisco/gestion/customer-prospect/customer-prospect.component';
import { CreateEditProspectComponent } from 'src-adisco/gestion/customer-prospect/create-edit-prospect/create-edit-prospect.component';
import { MyCategoriesComponent } from 'src-adisco/gestion/my-categories/my-categories.component';
import { MyAccountComponent } from 'src-adisco/my-account/my-account.component';
import { MyPartnersComponent } from 'src-ironside/list-partners/my-partners/my-partners.component';
import { MyFavouritesComponent } from 'src-ironside/my-favourites/my-favourites.component';
import { YellowFocusComponent } from 'src-ironside/yellow-focus/yellow-focus.component';
import { MyAccountIronsideComponent } from 'src-ironside/my-account/my-account-ironside.component';
import { BreadCrumbComponent } from 'src-ironside/shared/components/bread-crumb/bread-crumb.component';
import { ResourcesColumnComponent } from './shared/components/dynamic-component-shared/table/dynamic-columns/resources-column/resources-column.component';
import { SplitButtonModule } from 'primeng/splitbutton';
import { NewsDetailDialogComponent } from 'src-ironside/shared/components/dialogs/news-detail-dialog/news-detail-dialog.component';
import { PartnersDetailComponent } from 'src-ironside/list-partners/partners-detail/partners-detail.component';
import { KeywordSearchComponent } from './shared/components/keyword-search/keyword-search.component';
import { NotificationListComponent } from 'src-ironside/shared/components/notification-list/notification-list.component';
// import { ChangePasswordComponent } from 'src-ironside/my-account/change-password/change-password';
import { ComparatorComponent } from 'src-ironside/shared/components/comparator/comparator.component';
import { ModifyFavoriteComponent } from 'src-ironside/my-favourites/modify-favorite/modify-favorite';
import { FormattedTextContentComponent } from './shared/components/dynamic-component-shared/dynamic-text-content/formatted-text-content.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { sortByLabelPipe } from './shared/utils/sort.pipe';
import { RenamePriceLevelPipe } from './shared/core/pipes/rename-price-level.pipe';
import { ResourceFileRedirectComponent } from './shared/components/resource-file-redirect/resource-file-redirect.component';
import { CalendarModule } from 'primeng/calendar';
import { FrameImportComponent } from './shared/components/frame-import/frame-import.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FrameValidationComponent } from './shared/components/frame-validation/frame-validation.component';
import { HeaderFrameModuleComponent } from './shared/components/frame-import/header-frame-module/header-frame-module.component';
import { ContactPageComponent } from 'src-ironside/contact-page/contact-page.component';
import { ChiffrePageComponent } from 'src-ironside/dowload-page/chiffre-page.component';
import { CustomPaginatorComponent } from 'src-ironside/shared/components/custom-paginator/custom-paginator.component';
import { TranslateDynamicLanguagePipe } from 'src-ironside/pipes/translateDynamicLanguage.pipe';
import { ProductComparatorIronsideComponent } from 'src-ironside/product-comparator-ironside/product-comparator-ironside.component';
import { TranslateDynamicLanguageTablePipe } from 'src-ironside/pipes/translateDynamicLanguageTable.pipe';
import { DashToSpacePipe } from 'src-ironside/pipes/dash-to-space.pipe';
import { PasswordModule } from 'primeng/password';
import { FournisseurDetailComponent } from 'src-ironside/fournisseurs-ironside/fournisseur-detail/fournisseur-detail.component';
import { ExternalDownloadComponent } from 'src-ironside/dowload-page/external-download/external-download.component';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { MultilangueFormattedTextComponent } from './shared/components/dynamic-component-shared/multilangue-formatted-text/multilangue-formatted-text.component';
import { LogisticImportComponent } from './shared/components/logistic-import/logistic-import.component';
import { HeaderLogisticImportComponent } from './shared/components/logistic-import/header-logistic-import/header-logistic-import.component';
import { ContentLogisticImportComponent } from './shared/components/logistic-import/content-logistic-import/content-logistic-import.component';
import { MatRippleModule } from '@angular/material/core';
import { ExportDataProductComponent } from 'src-ironside/new-product/export-data-product/export-data-product.component';
import { StoreModule } from '@ngrx/store';
import { flowReducer } from 'src-ironside/stores/flow/flow.reducer';
import { EffectsModule } from '@ngrx/effects';
import { FlowEffects } from 'src-ironside/stores/flow/flow.effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

export const protectedResourceMap: [string, string[]][] = [
    ['https://graph.microsoft.com/v1.0/me', ['user.read']],
    ['https://management.azure.com', ['https://management.azure.com//user_impersonation']],
];

registerLocaleData(localeFr);

const isIE =
    window.navigator.userAgent.indexOf('MSIE ') > -1 ||
    window.navigator.userAgent.indexOf('Trident/') > -1;

const msalGuardConfig: MsalGuardConfiguration = {
    interactionType: InteractionType.Popup,
    // authRequest: {
    //   scopes: ['openid', 'profile'],
    // },
    // loginFailedRoute: '/login-failed',
};

const msalInterceptorConfig: MsalInterceptorConfiguration = {
    interactionType: InteractionType.Popup,
    protectedResourceMap: new Map(),
};

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

@NgModule({
    declarations: [
        BooleanToFrenchPipe,
        AppComponent,
        ExtractEntityNamePipe,
        columnRenamePipe,
        HeaderComponent,
        SideNavComponent,
        DashboardComponent,
        DashboardUserComponent,
        CheckboxComponent,
        DropdownComponent,
        TextareaComponent,
        TextboxComponent,
        RadioComponent,
        AdminHomePageComponent,
        TableComponent,
        CreerPersonnephysiqueComponent,
        PersonMoraleComponent,
        LoginComponent,
        MenuComponent,
        CategorieComponent,
        ProduitAdminComponent,
        DiaologHostComponent,
        TabContentComponent,
        DialogComponent,
        LogoutComponent,
        BibliothequeMultimediaComponent,
        EntiteDirective,
        FormFieldHostDirective,
        AccueilComponent,
        HeaderUserComponent,
        NotificationComponent,
        ImageComponent,
        FooterUserComponent,
        FournisseursComponent,
        CataloguesComponent,
        DetailCatalogueComponent,
        AssociesComponent,
        MesDevisComponent,
        VisualisationComponent,
        NewsCarouselComponent,
        ImportFichierComponent,
        ExportFichierComponent,
        FiltrerChampComponent,
        LayoutConditionsComponent,
        GenericDialogComponent,
        FiltrePredifiniDialogComponent,
        SuppressionDialogComponent,
        ConfirmationDialogComponent,
        ChampsComponent,
        FooterAdminComponent,
        AdminUserGroupParameterComponent,
        ForgotPasswordComponent,
        ChangerMotDePasseComponent,
        RetrievePasswordComponent,
        ResourceFileRedirectComponent,
        UserComponent,
        AccountComponent,
        SearchProductComponent,
        ConfirmRemoveComponent,
        RechercheProduitComponent,
        NewsComponent,
        CatalogueMenuComponent,
        CatalogueMenuRespComponent,
        CatalogueMenuDialogComponent,
        ProduitComponent,
        CaracProductComponent,
        MostConsultedComponent,
        AccessoriesComponent,
        ProductOptionsComponent,
        FournisseurComponent,
        BurgerComponent,
        ExtractEntityNamePipe,
        TemplateComponent,
        TemplateDeuxColonneEditionComponent,
        TemplateDeuxColonneLectureComponent,
        TemplateRefactorComponent,
        EmailPopupDialogComponent,
        TemplateParameterComponent,
        TemplateEditComponent,
        CarouselComponent,
        RechercheAvanceeComponent,
        CguPopupComponent,
        GestionComponent,
        CreateEditProductComponent,
        DataTableComponent,
        TextEditorComponent,
        ActualiteComponent,
        CreateDevisComponent,
        InfosDevisComponent,
        OutilsDevisComponent,
        LignesDevisComponent,
        ClosePopupComponent,
        GestionMarquesComponent,
        GestionFournisseursComponent,
        GestionAssocieComponent,
        GestionClientsComponent,
        TemplateParameterComponent,
        TemplateRefactorComponent,
        TemplateViewComponent,
        TemplateEditComponent,
        DataTableComponent,
        PrintDevisComponent,
        ArticleManuscritDevisComponent,
        ModaleOrdreDevisComponent,
        MultiLangueComponent,

        DateComponent,
        MultiSelectDropdownComponent,
        ImageComponent,
        PictoComponent,
        SearchableTextfieldComponent,
        TextboxlistComponent,
        AddressComponent,
        LabelComponent,
        DynamicTableRowComponent,
        GenricTableRowComponent,
        TabExtranetComponent,
        GenricTableRowComponent,
        ImageColumnComponent,
        PrimitiveColumnComponent,
        ObjectColumnComponent,
        ColorColumnComponent,
        MultilangueColumnComponent,
        PictoColumnComponent,
        RestrictionsComponent,
        FonctionalitesComponent,
        ArchivesComponent,
        TaskSchedulerComponent,
        AppMenuItemComponent,
        DroitItemComponent,
        NestedValueDataTableComponent,
        DynamicFieldFormComponent,
        DynamicDocumentManageFieldComponent,
        ParameterLinkComponent,
        BackofficeMenuComponent,
        // BEFOR
        BeforCaracProductComponent,
        VideoComponent,
        BarquettesTableComponent,
        FilmsTableComponent,
        DynamicContentComponent,
        ModaleContentComponent,
        GeneralDynamicContentComponent,
        GeneralDynamicContentItemComponent,
        ModalePreviewComponent,
        ContactComponent,

        // ADISCO
        CategoriesComponent,
        ProductDetailComponent,
        GeneralInfoComponent,
        DetailInfoComponent,
        SlideProductComponent,
        ProductComparatorComponent,
        ProductComparatorIronsideComponent,
        SuppliersComponent,
        DetailSupplierComponent,
        SlideNewsComponent,
        MembersComponent,
        DetailMemberComponent,
        FormattedTextContentComponent,
        GestionAdiscoComponent,
        MemberFileComponent,
        CustomerProspectComponent,
        CreateEditProspectComponent,
        MyCategoriesComponent,
        MyAccountComponent,

        ProductCatalogComponent,
        ButtonFieldComponent,
        LinkbuttonComponent,

        // Ironside
        ProductCatalogComponent,
        ProductCatalogDialogComponent,
        NewProductComponent,
        NewProductDetailComponent,
        TabviewProductComponent,
        ListProductComponent,
        FournisseursIronsideComponent,
        ListPartnersComponent,
        MyPartnersComponent,
        MyFavouritesComponent,
        YellowFocusComponent,
        MyAccountIronsideComponent,
        BreadCrumbComponent,
        ResourcesColumnComponent,
        NewsDetailDialogComponent,
        PartnersDetailComponent,
        KeywordSearchComponent,
        NotificationListComponent,
        ContactPageComponent,
        ChiffrePageComponent,
        CustomPaginatorComponent,
        ExportDataProductComponent,
        // ChangePasswordComponent,
        ComparatorComponent,
        ModifyFavoriteComponent,
        FournisseurDetailComponent,
        ExternalDownloadComponent,

        // PIPE
        sortByLabelPipe,
        RenamePriceLevelPipe,
        FrameImportComponent,
        FrameValidationComponent,
        HeaderFrameModuleComponent,
        MultilangueFormattedTextComponent,
        LogisticImportComponent,
        HeaderLogisticImportComponent,
        ContentLogisticImportComponent,
    ],
    imports: [
        BrowserModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
            defaultLanguage: localStorage.getItem('lang') ?? 'fr',
        }),
        StoreModule.forRoot({
            flow: flowReducer,
        }),
        EffectsModule.forRoot([FlowEffects]),
        StoreRouterConnectingModule.forRoot(),
        StoreDevtoolsModule.instrument({
            maxAge: 25,
            logOnly: environment.production,
        }),
        AppRoutingModule,
        AngularEditorModule,
        HttpClientModule,
        BrowserAnimationsModule,
        MatProgressSpinnerModule,
        MatFormFieldModule,
        MatSelectModule,
        MatProgressBarModule,
        SplitButtonModule,
        FileUploadModule,
        AccordionModule,
        TableModule,
        TabViewModule,
        DialogModule,
        DropdownModule,
        OverlayPanelModule,
        ProgressSpinnerModule,
        CalendarModule,
        MultiSelectModule,
        RadioButtonModule,
        CarouselModule,
        GalleriaModule,
        PaginatorModule,
        PanelModule,
        CheckboxModule,
        MaterialModules,
        IconModule,
        SharedModule,
        MatTabsModule,
        MatSortModule,
        FormsModule,
        ReactiveFormsModule,
        MatDividerModule,

        QRCodeModule,

        // NgxChartModule,
        NgxImageZoomModule,
        NgApexchartsModule,
        NgImageSliderModule,
        DragDropModule,
        CdkMenuModule,
        MenuModule,
        FlexLayoutModule,
        CommonModule,
        ToastModule,
        ConfirmPopupModule,
        SkeletonModule,
        PipeModule.forRoot(),
        PasswordModule,
        MsalModule.forRoot(
            new PublicClientApplication({
                auth: {
                    clientId: environment.MSclientID, // Application (client) ID from the app registration
                    authority: `https://login.microsoftonline.com/consumers`, // The Azure cloud instance and the app's sign-in audience (tenant ID, common, organizations, or consumers)
                    redirectUri: environment.MSredirectUri,
                },
                cache: {
                    cacheLocation: 'localStorage',
                    storeAuthStateInCookie: isIE, // Set to true for Internet Explorer 11
                },
            }),
            msalGuardConfig,
            msalInterceptorConfig
        ),
        MatButtonModule,
        MatDialogModule,
        MatInputModule,
        JwtModule.forRoot({
            config: { tokenGetter: () => localStorage.getItem('token') },
        }),
        PdfViewerModule,
        MatRippleModule,
    ],
    providers: [
        DatePipe,
        DecimalPipe,
        TranslateDynamicLanguagePipe,
        DashToSpacePipe,
        TranslateDynamicLanguageTablePipe,
        TableComponent,
        ExtractEntityNamePipe,
        columnRenamePipe,
        TranslatePipe,
        UpperCasePipe,
        sortByLabelPipe,
        { provide: LOCALE_ID, useValue: 'fr-FR' },
        MessageService,
        { provide: HTTP_INTERCEPTORS, useClass: RefEanValidationInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: BasicAuthInterceptor, multi: true },
        { provide: MatPaginatorIntl, useValue: getFrenchPaginatorIntl() },
    ],
    // { provide: HTTP_INTERCEPTORS, useClass: KeyClockInterceptor, multi: true },
    // { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },

    bootstrap: [AppComponent],
})
export class AppModule {}
